/**
 * State
 * @type {Object}
 */
const state = {
    data: null,
    filters: {
        declaration: {}
    }
}

/**
 * Getters
 * @type {Object}
 */
const getters = {}

/**
 * Actions
 * @type {Object}
 */
const actions = {

    authorized( {commit} ) {
        return new Promise( (resolve, reject) => {

            this.$xhr.get('/api/auth/user/').then( ( {result} ) => {
                commit('set', result);
                resolve(result);
            }).catch(reject);
        });
    },

    login( {commit}, {email, password}) {

        return new Promise( (resolve, reject) => {

            this.$xhr.post('/api/auth/login/', {email, password} ).then( ( {result} ) => {
                commit('set', result);
                resolve(result);
            }).catch(reject);
        });
    },

    logout( {commit}) {

        this.$xhr.post('/api/auth/logout/').then( ( {result} ) => {
            location.assign('/login/');
        }).catch(() => {
            console.error('Can\'t log out');
        });
    },
    addDeclarationFilter({commit}, params) {
        commit('setDeclarationFilter', params);
    }
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {
    set(state, user) {

        // user.name = ( user.opdrachtnemer ) ? user.opdrachtnemer.naam : user.opdrachtgever.naam;

        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
        let initials = [...user.name.matchAll(rgx)] || [];

        initials = (
          (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();

        user.is_applicant = ( user.opdrachtgever != null && user.opdrachtgever != undefined );
        user.is_translator = ( user.opdrachtnemer != null && user.opdrachtnemer != undefined );

        state.data = user;
        state.data.initials = initials;
        state.filters = {
            declaration: {}
        };
    },

    clear(state) {
        state.data = null;
    },

    setDeclarationFilter(state, params) {
        state.filters.declaration = params;
    }
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
